import { ISelectedFilters } from 'src/components/ProductList/interfaces/ISelectedFilters';

export const filterVariants = (variants: Array<GQL.IProductVariant>, filters: ISelectedFilters) => {
    const filteredVariants = new Array<GQL.IProductVariant>();

    for (const variant of variants) {
        let valid = false;
        const filteredAttributeIds = Object.keys(filters);
        if (filteredAttributeIds.length == 0) {
            valid = true;
        }

        for (const attributeId of filteredAttributeIds) {
            let tempValid = false;
            if (!Array.isArray(filters[attributeId]) || filters[attributeId].length == 0) {
                tempValid = true;
            }

            for (const filteredValue of filters[attributeId]) {
                const value = (variant.definition || {})[attributeId];

                if (value == undefined) {
                    break;
                }

                if (Array.isArray(value)) {
                    if (value.some(v => v == filteredValue.value)) {
                        tempValid = true;
                        break;
                    }
                } else if (value == filteredValue.value) {
                    tempValid = true;
                    break;
                }
            }

            if (tempValid) {
                valid = tempValid;
                break;
            }
        }

        if (valid) {
            filteredVariants.push(variant);
        }
    }

    return filteredVariants;
};



// WEBPACK FOOTER //
// ./src/helpers/products/filterVariants.ts